import { CardContent } from './shared.style';
import { svgIcons } from '@exploration/icons';
import { headlessPageDataAtom, parseSanitizeItem } from '@exploration/ui-utils';
import { BaseCard } from '@midwest/web/card';
import { useAuth } from '@thrivent-web/authentication';
import { MDSButton, MDSText } from '@thrivent/midwest-web';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';

// --------------------------------------------------------------------------

const CardActionsDivider = styled.hr`
  display: block;
  text-align: center;
  margin-bottom: 0.5rem;
  height: 1px;
  border: none;
  background: ${(p) => p.theme.midwestColors.neutralLightStrong};
  width: 100%;
`;

const LinkList = styled.ul`
  list-style: none;
  padding-left: 0;
  gap: 1rem;
  display: flex;
  flex-direction: column;

  a {
    text-decoration: underline;
  }
`;

// --------------------------------------------------------------------------

export const LogInCard = ({ className }: { className?: string }) => {
  const pageData = useAtomValue(headlessPageDataAtom);
  const { text, callToAction, list } = pageData ?? {};
  const { signinRedirect } = useAuth();

  return (
    <BaseCard className={className} raised={true}>
      <CardContent
        icon={text?.['login-card-icon'] as svgIcons}
        headline={text?.['login-card-title']}
        subHeadline={text?.['login-card-description']}
        buttonComponent={
          <MDSButton onClick={async () => await signinRedirect()}>
            {callToAction?.['login-card-button']?.text}
          </MDSButton>
        }
      />
      <CardActionsDivider />
      <div>{parseSanitizeItem(text?.['login-card-sub-text'])}</div>
      <div>
        <MDSText.BodyHeavySm as="h3">
          {text?.['login-card-links-title']}
        </MDSText.BodyHeavySm>
        {!!list?.['login-card-list']?.length && (
          <LinkList>
            {(list?.['login-card-list'] ?? []).map((text, i) => (
              <MDSText.BodyRegDefault as="li" key={text?.key ?? i}>
                {parseSanitizeItem(text?.text)}
              </MDSText.BodyRegDefault>
            ))}
          </LinkList>
        )}
      </div>
    </BaseCard>
  );
};
